<template>
    <v-dialog v-model="modalresultado" 
    :transition="fullscreen?'dialog-bottom-transition':'dialog-transition'" persistent :fullscreen="fullscreen" 
    :width="width" scrollable>
        <v-card class="fondo-curso-modal">
            <v-toolbar class="cerrar cerrar-bien" v-if="nameResult == 'bien'" @click="$emit('click', false), $emit('bienAvanzar')">
                <span><h3>Correto</h3></span>
                <button v-if="mostrarCerrar"  class="hvr hvr-scale close">
                    <img src="@/assets/imagenes_compartidas/modalresult-avanzar.svg" alt="botón cerrar">
                </button>
            </v-toolbar>
            <v-toolbar class="cerrar" v-if="nameResult == 'mal'" @click="$emit('click', false), $emit('malAvanzar')">
                <div class="cerrar-titulo"><h3>Incorreto</h3></div>
                <button v-if="mostrarCerrar" class="hvr hvr-scale close">
                    <img src="@/assets/imagenes_compartidas/evaluacion-cerrar-black.svg" alt="botón cerrar">
                </button>
            </v-toolbar>
            <v-card-text>
                <v-flex contain class="dialog-content" text-xs-center>
                    <img :src="require('@/assets/imagenes_compartidas/'+nameResult+'.svg')" alt="bien">
                </v-flex>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
    export default {
        model: {
            prop: 'modalresultado',
            event: 'click'
        },
        props: {
            modalresultado: Boolean,
            width: {
                type: String,
                default: '700px'
            },
            fullscreen: {
                type: Boolean,
                default: true,
            },
            mostrarCerrar: {
                type: Boolean,
                default: true
            },
            nameResult:{
                type: String,
                default:'bien'
            },
        },
        data() {
            return {
                
            }
        },
        watch: {
            fullscreen: function(value){
                if(value){
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../sass/helpers/variables';
    .cerrar {
        padding-bottom: 0;
        height: 130px;
        background: #ED7501;
        box-shadow: none;
        top: 30vh;
        display: flex;
        justify-content:center;
        justify-items:flex-end;
        align-items: center;
        flex-flow: wrap;
        img{
            width: 30px;
            height: 30px;
        }
        .cerrar-titulo{
            display: flex;
        }
        .close{
            display: flex;
            position: absolute;
            right: 10px;
        }
    }
    .cerrar-bien{
        background:#398B35; 
        h3{
            color: white;
        }
    }

    .dialog-content {
        max-width: 1100px;
        // max-width: 100%;
        margin: auto;
        padding: 5px;
        margin-top:30vh;
        align-items: center;
        font-size: 0.8em;
        @media (max-height: 800px){
            align-items: start;
        }
    }

    .fullscreen {
        @media (min-height: 800px){
            height: 70vh;
        }
    }
    .fondo-curso-modal {
        background: rgba($color: black, $alpha: 0.7);
    }
</style>
